export const whyketto = [
  {
    'imageClass': 'crowd1',
    'text': 'Industry’s best fundraising success rate',
    'lazyImage': '/assets/images/homepage/why-ketto.png?w=auto'
  },
  {
    'imageClass': 'crowd2',
    'text': 'Supported By 55,00,000+ Donors ',
    'lazyImage': '/assets/images/homepage/why-ketto.png?w=auto'
  },
  {
    'imageClass': 'crowd3',
    'text': 'Easy-To-Manage Tools To Boost Results',
    'lazyImage': '/assets/images/homepage/why-ketto.png?w=auto'

  },
  {
    'imageClass': 'crowd4',
    'text': 'Receive donations via all popular payment modes',
    'lazyImage': '/assets/images/homepage/why-ketto.png?w=auto'
  },
  {
    'imageClass': 'crowd5',
    'text': 'Get Expert Support 24/7',
    'lazyImage': '/assets/images/homepage/why-ketto.png?w=auto'

  },
  {
    'imageClass': 'crowd6',
    'text': 'A Dedicated Smart-Dashboard',
    'lazyImage': '/assets/images/homepage/why-ketto.png?w=auto'

  },
  {
    'imageClass': 'crowd7',
    'text': 'Withdraw Funds Without Hassle',
    'lazyImage': '/assets/images/homepage/why-ketto.png?w=auto'

  },
  {
    'imageClass': 'crowd8',
    'text': 'International Payment Support',
    'lazyImage': '/assets/images/homepage/why-ketto.png?w=auto'

  }
];
